import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductShowcase, { ShowcaseProduct } from './ProductShowcase';
import Calculator from './Calculator';

const TravelInsuranceSection: React.FC = () => {
  const { t } = useTranslation();

  const products: ShowcaseProduct[] = [
    {
      id: 't1',
      company: 'Travel Co',
      name: t('travelInsurance.product1.name'),
      description: t('travelInsurance.product1.description'),
      features: [
        t('travelInsurance.product1.feature1'),
        t('travelInsurance.product1.feature2'),
        t('travelInsurance.product1.feature3'),
      ],
      imageUrl: '/path-to-travel-image1.jpg',
      price: '$3.50',
      tag: 'Popular',
    },
  ];

  return (
    <Box>
      <ProductShowcase
        title={t('travelInsurance.title')}
        products={products}
        learnMoreLabel={t('travelInsurance.learnMore')}
      />
      <Box mt={4}>
        <Calculator />
      </Box>
    </Box>
  );
};

export default TravelInsuranceSection;
